import { render } from "./BlockInfographic.vue?vue&type=template&id=228f9919&scoped=true"
import script from "./BlockInfographic.vue?vue&type=script&lang=js"
export * from "./BlockInfographic.vue?vue&type=script&lang=js"

import "./BlockInfographic.vue?vue&type=style&index=0&id=228f9919&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228f9919"]])

export default __exports__